import { makeStyles } from '../../../../../../../../styles';
export const isAlwaysEnabledClassName = 'list-item-is-always-enabled';
export const hasErrorClassName = 'list-item-has-error';
export const isDisabledClassName = 'list-item-is-disabled';
const makeGroupStyles = (theme) => ({
    display: 'flex',
    alignItems: 'center',
    '& > :not(.list-item-label):not(span)': {
        height: theme.spacing(2.5),
        width: theme.spacing(2.5),
        cursor: 'pointer',
    },
});
const makeIconStyles = (theme) => ({
    fontSize: `${theme.spacing(2.5)} !important`,
    verticalAlign: 'initial !important',
    padding: 0,
    color: theme.colors.gray[500],
});
export default makeStyles((theme) => {
    const iconStyles = makeIconStyles(theme);
    const groupStyles = makeGroupStyles(theme);
    return {
        item: {
            backgroundColor: theme.colors.gray[0],
            borderRadius: theme.spacing(1),
            marginBottom: theme.spacing(1),
            padding: theme.spacing(1.2, 1.5),
            display: 'flex',
            justifyContent: 'space-between',
            cursor: 'pointer',
            alignItems: 'center',
            width: '100%',
            overflow: 'hidden',
            position: 'relative',
            '& button': {
                padding: 0,
                background: 'none',
                border: 'none',
            },
            '&:hover': {
                '& button': {
                    visibility: 'visible',
                },
            },
            [`&.${isAlwaysEnabledClassName}`]: {
                backgroundColor: theme.colors.gray.neutral,
                padding: theme.spacing(1, 1.5, 1, 4),
            },
            [`&.${hasErrorClassName}`]: {
                backgroundColor: theme.colors.error.light,
                padding: theme.spacing(1, 1.5, 1, 4),
            },
            [`&.${isDisabledClassName}`]: {
                backgroundColor: theme.colors.gray.neutral,
                padding: theme.spacing(1, 1.5, 1, 1.5),
            },
        },
        itemSelected: {
            background: theme.colors.primary.light,
        },
        itemSelectedBar: {
            width: '4px',
            height: '100%',
            background: theme.colors.primary.main,
            position: 'absolute',
            left: '0',
        },
        chevronIcon: {
            fontSize: '17px',
            color: theme.colors.gray['700'],
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
        },
        icon: Object.assign({}, iconStyles),
        pinIcon: Object.assign(Object.assign({}, iconStyles), { marginTop: '2px' }),
        editIcon: Object.assign(Object.assign({}, iconStyles), { fontSize: '19px !important', marginBottom: '1px' }),
        dragIcon: Object.assign(Object.assign({}, iconStyles), { cursor: 'grab' }),
        infoIcon: Object.assign(Object.assign({}, iconStyles), { paddingTop: '1px' }),
        leftGroup: Object.assign(Object.assign({}, groupStyles), { minWidth: 0, flexShrink: 1 }),
        rightGroup: Object.assign(Object.assign({}, groupStyles), { '& > *': {
                marginLeft: theme.spacing(1.25),
            } }),
        itemLabel: Object.assign(Object.assign({}, theme.typography.body2), { flexShrink: 1, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', paddingBottom: '1px', marginLeft: theme.spacing(0.5), marginRight: theme.spacing(0.5) }),
        hideUntilHover: {
            visibility: 'hidden',
        },
    };
});
//# sourceMappingURL=EventSelectorCardItem.styles.js.map